module.exports = __webpack_public_path__ + "static/media/lasGolondrinas.a0bb8375.webp";